import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Flex } from 'roo-ui/components';
import { CalendarDay, CalendarEmptyDay } from 'components/DatePicker/CalendarDay';

const CalendarDaysWrapper = styled(Flex)`
  flex-wrap: wrap;
  margin-bottom: 2px;
  margin-right: 2px;
`;

const getCustomDateProps = (isInRange, day) => {
  const props = {
    selected: day.selected,
    highlighted: isInRange(day.date),
    selectable: day.selectable,
  };

  return props;
};

const CalendarDays = ({ weeks, month, year, getDateProps, onMouseEnterOfDay, isInRange }) => (
  <CalendarDaysWrapper>
    {weeks.map((week) =>
      week.map((day, index) => {
        const onMouseEnter = () => onMouseEnterOfDay(day);
        const key = `${year}${month}${index}`;
        if (!day) return <CalendarEmptyDay key={key} />;

        return (
          <CalendarDay key={key} {...getDateProps({ dateObj: day, onMouseEnter })} {...getCustomDateProps(isInRange, day)}>
            {day.date.getDate()}
          </CalendarDay>
        );
      }),
    )}
  </CalendarDaysWrapper>
);

CalendarDays.defaultProps = {
  isInRange: () => {},
  onMouseEnterOfDay: () => {},
};

CalendarDays.propTypes = {
  month: PropTypes.number.isRequired,
  year: PropTypes.number.isRequired,
  weeks: PropTypes.arrayOf(PropTypes.array).isRequired,
  getDateProps: PropTypes.func.isRequired,
  onMouseEnterOfDay: PropTypes.func,
  isInRange: PropTypes.func,
};

export default CalendarDays;
